import { TagProps } from "@chakra-ui/react";
import { Meeting } from "features/Resources/Meeting/models";
import {
  blueStyles, errorStyles, grayStyles, greenStyles, orangeStyles,
} from "components/Tag/Status/styles";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { titleize } from "helpers/string";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";

function meetingStatusStyles(status: Meeting["status"]) {
  switch (status) {
    case "completed":
      return greenStyles;
    case "failed":
      return errorStyles;
    case "removed":
    case "skipped":
      return grayStyles;
    case "pending_scheduling":
      return orangeStyles;
    case "scheduled":
      return blueStyles;
    default:
      return {};
  }
}

interface MeetingStatusProps extends TagProps {
  meeting: Meeting;
}

export function FullMeetingStatus({ meeting, ...rest }: MeetingStatusProps) {
  const unscheduledStatus = meeting.meetingType === "individual" ? "Not Scheduled" : "Not Added";
  const statusText = meeting.status === "pending_scheduling" ? unscheduledStatus : titleize(meeting.status);
  return (
    <BaseActionStatus {...(meetingStatusStyles(meeting.status))} {...rest}>
      {statusText}
    </BaseActionStatus>
  );
}

export function ShowMeetingStatus({ meeting, ...rest }: MeetingStatusProps) {
  return (
    <HorizontalGreyBlackField
      label="Status"
      labelContainerProps={longAttributeStyles.labelContainerProps}
    >
      <FullMeetingStatus meeting={meeting} {...rest} />
    </HorizontalGreyBlackField>
  );
}
